import React, { useState, useEffect } from "react";
import { jwtDecode } from "jwt-decode";
import { useParams } from "react-router-dom";
import { getInvoiceById, getPlacesOfService } from "../afinanceapi";
import { getUserPracticeById, getAccountById } from "../api";
import CreateReceiptModal from "../Components/Accounts/Receipt";
import CreateInvoiceModal from "../Components/Accounts/CreateInvoice";

function Invoices() {
  const { id, accountId } = useParams(); // accountId and invoice id from URL
  const isNew = id === "1";

  const [invoice, setInvoice] = useState(null);
  const [account, setAccount] = useState(null);
  const [practice, setPractice] = useState([]);
  const [showReceiptModal, setShowReceiptModal] = useState(false);
  const [receiptAccount, setReceiptAccount] = useState(null);
  const [receiptInvoiceNumber, setReceiptInvoiceNumber] = useState(null);
  const [placesOfService, setPlacesOfService] = useState([]);

  useEffect(() => {
    async function getData() {
      try {
        const token = sessionStorage.getItem("user");
        if (!token) return console.error("⛔ No user token found!");

        const user = jwtDecode(token);
        const practiceData = await getUserPracticeById(user._id);
        setPractice(practiceData);

        const accountData = await getAccountById(accountId);
        if (!accountData) return console.error("⛔ No account found");
        setAccount(accountData);

        const placesOfServiceData = await getPlacesOfService();
      setPlacesOfService(placesOfServiceData);

        if (!isNew) {
          const fetchedInvoice = await getInvoiceById(id);
          setInvoice(fetchedInvoice);
        }
      } catch (error) {
        console.error("⛔ Error in invoice setup:", error);
      }
    }

    getData();
  }, [id, accountId]);

  if ((!invoice && !isNew) || !account || practice.length === 0) {
    return <p className="text-center mt-4">Loading invoice...</p>;
  }

  return (
    <div style={{ marginTop: "65px" }} className="ms-3 me-3">
      <CreateInvoiceModal
        account={account}
        practice={practice}
        placesOfService={placesOfService}
        initialInvoice={isNew ? null : invoice}
        onOpenReceipt={(account, invoiceNumber) => {
          setReceiptAccount(account);
          setReceiptInvoiceNumber(invoiceNumber);
          setTimeout(() => setShowReceiptModal(true), 0);
        }}
        onInvoiceUpdated={() => {}}
      />

      {showReceiptModal && receiptAccount && (
        <CreateReceiptModal
          show={showReceiptModal}
          handleClose={() => setShowReceiptModal(false)}
          account={receiptAccount}
          invoiceNumber={receiptInvoiceNumber}
        />
      )}
    </div>
  );
}

export default Invoices;
